import { Box } from "@mui/material";
import { ReactComponent as ActionCompleted } from "assets/ActionCompleted.svg";
import { ReactComponent as PlanCompleted } from "assets/PlanCompleted.svg";
import { setCardsCompletedPrev } from "components/app/App.slice";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { tokens } from "styles/Tokens";
import { getLoggedInUserHltId } from "utils/CommonFunctions";
import { feedbackTypes } from "utils/Types";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { reset } from "../Feedback/Feedback.slice";
import GiveFeedback from "../Feedback/GiveFeedback";

function RecognitionsDialog() {
  const dispatch = useAppDispatch();

  const cardsCompletedPrev = useAppSelector((state) => state.app.cardsCompletedPrev);
  const myPlanDetails = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const { cardsCompleted, totalCards } = myPlanDetails;
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isEmpty(myPlanDetails) && totalCards > 0) {
      if ((cardsCompletedPrev === 0 || cardsCompletedPrev === -1) && cardsCompleted === 1) {
        setOpen(true);
      }
      if (cardsCompleted === totalCards && cardsCompleted !== cardsCompletedPrev) {
        setOpen(true);
      }
    }
  }, [cardsCompletedPrev, cardsCompleted, totalCards, myPlanDetails]);

  const closeHandler = () => {
    dispatch(reset());
    dispatch(setCardsCompletedPrev(myPlanDetails.cardsCompleted));
    setOpen(false);
  };

  return (
    <>
      {open && (
        <DialogFormation
          title={totalCards === cardsCompleted ? "Plan Completed" : "Action Completed"}
          openDialog={open}
          handleClose={closeHandler}
        >
          <div>
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={"30px"} paddingY={"15px"}>
              {totalCards === cardsCompleted ? <PlanCompleted /> : <ActionCompleted />}
              <Box display={"flex"} flexDirection={"column"} textAlign={"left"}>
                <Typography variant="h3" color={tokens.Text.General.Color}>
                  Great Job!
                </Typography>
                <Box sx={{ marginTop: "8px" }}>
                  {totalCards === cardsCompleted ? (
                    <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                      You have fully completed “{myPlanDetails.name}”
                    </Typography>
                  ) : (
                    <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                      You have completed this action
                    </Typography>
                  )}
                  <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                    Keep up the good work.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>
          {totalCards === cardsCompleted && (
            <Box marginTop={"32px"}>
              <GiveFeedback
                id={process.env.REACT_APP_FEEDBACK_TYPES_PLAN_COMPLETED}
                type={feedbackTypes.PlanCompleted}
                showActionButtons
                onSkipClickHandler={closeHandler}
                afterSubmitHandler={closeHandler}
                payloadData={{
                  myPlanId: myPlanDetails.id,
                  cmsPlanId: myPlanDetails.cmsPlanId,
                  planTitle: myPlanDetails.name,
                  innCode: myPlanDetails.innCode,
                  planMemberType: myPlanDetails?.owners?.includes(getLoggedInUserHltId) ? "Owner" : "Member",
                  templatePlanId: myPlanDetails.templatePlanId,
                  planSource: myPlanDetails.planSource
                }}
              />
            </Box>
          )}
        </DialogFormation>
      )}
    </>
  );
}

export default RecognitionsDialog;
